var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "material-design-icon scanner-icon",
      attrs: {
        "aria-hidden": _vm.decorative,
        role: "img",
        "aria-label": _vm.title
      }
    },
    [
      _c(
        "svg",
        {
          staticClass: "material-design-icon__svg",
          attrs: {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: _vm.fillColor
          }
        },
        [
          _c("title", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d:
                "M4.2,10.7L19.8,5L20.5,6.9L6.4,12H19C20.1,12 21,12.9 21,14V18C21,19.1 20.1,20 19,20H5C3.9,20 3,19.1 3,18V12.5C3,11.7 3.5,10.9 4.2,10.7M17,17H19V15H17V17M5,17H15V15H5V17Z"
            }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-44032ddc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44032ddc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-material-design-icons/scanner.vue
// module id = 10yS
// module chunks = 1